import { makeOptionallyAuthenticatedQuery } from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'
import type { EuMaxTaxExposureDto } from '@b-stock/listing-api-client'

import getEuTaxClient from './getEuTaxClient'

// ACTIVE_BUYER max-exposure endpoint. Form values flow through the
// query key so cache invalidates when the buyer edits the modal.
// Unavailable state is a real answer — pass it through and let the
// display render "unavailable" rather than nothing (FR-020).
const fetchEuMaxTaxExposure = async (
  accessToken: string | null,
  listingId: string,
  formSingleBid: number,
  buyerAddressId: string | undefined,
  formProxyMaxBid: number | undefined,
  buyerFeeCents: number | undefined,
  shippingCents: number | undefined
): Promise<EuMaxTaxExposureDto> => {
  const client = getEuTaxClient()
  const config = buildAxiosRequestConfig({ accessToken })
  const { data } = await client.getEuMaxTaxExposure(
    {
      listingId,
      formSingleBid,
      buyerAddressId,
      buyerFeeCents,
      shippingCents,
      formProxyMaxBid,
    },
    config
  )
  return data
}

const euTaxMaxExposureQuery = makeOptionallyAuthenticatedQuery(
  'euTaxMaxExposure',
  fetchEuMaxTaxExposure
)

export default euTaxMaxExposureQuery
